export enum SCREENING_QUESTION {
  SHORT_TEXT = 'short_text',
  MULTI_CHOICE = 'multi_choice',
  LIKERT_SCALE = 'likert_scale',
}

export const DEFAULT_SEGMENT = 'General';
